import { showNotification } from "@mantine/notifications"
import { Attachment } from "@features/comment"
import { fileToAttachment, MAX_ATTACHMENT_SIZE_MB } from "@/shared"

export default async function handleAttachments(attachments: File[]) {
  const MAX_TOTAL_SIZE_BYTES = MAX_ATTACHMENT_SIZE_MB * 1024 * 1024

  let totalNewAttachmentsSize = 0
  if (attachments && attachments.length > 0) totalNewAttachmentsSize = attachments.reduce((sum, file) => sum + file.size, 0)

  if (totalNewAttachmentsSize > MAX_TOTAL_SIZE_BYTES) {
    const totalSizeMB = (totalNewAttachmentsSize / (1024 * 1024)).toFixed(2)
    showNotification({ title: "Error de tamaño de archivos", message: `El tamaño total de los archivos (${totalSizeMB}MB) excede el límite máximo permitido (${MAX_ATTACHMENT_SIZE_MB}MB).`, color: "red" })
    return []
  }

  let processedAttachments: Attachment[] = []
  if (attachments && attachments.length > 0) {
    const attachmentPromises = attachments.map((file) => fileToAttachment(file))
    processedAttachments = await Promise.all(attachmentPromises)
  }
  return processedAttachments
}
